<template>
  <div class="trf-listagem-empresa">
    <div
      class="card mb-4"
      :class="cardBorderColor(dado)"
      v-for="(dado, indexDado) in dados"
      :key="indexDado"
    >
      <header class="card-header has-background-white-ter" @click="mostrarDados(indexDado)">
        <p class="card-header-title">{{ dado.empresa }}</p>
        <button class="card-header-icon" aria-label="more options">
          <span class="icon">
            <FontAwesomeIcon
              size="2x"
              :icon="controle[indexDado] ? 'fa-angle-up' : 'fa-angle-down'"
            />
          </span>
        </button>
      </header>
      <div class="card-content" :class="{ active: controle[indexDado] }">
        <table class="table is-borderless">
          <template
            v-for="(departamento, indexDepartamento) in dado.departamentos"
            :key="indexDepartamento"
          >
            <tr>
              <td colspan="2" class="has-text-weight-bold">{{ departamento.nome }}</td>
              <template
                v-for="(data, dataIndex) in colunasPeriodo"
                :key="dataIndex"
              >
                <td class="has-text-centered">
                  <template v-if="indexDepartamento == 0">
                    {{ data }}
                  </template>
                </td>
              </template>
            </tr>
            <template
              v-for="(tarefa, indexTarefa) in departamento.tarefas"
              :key="indexTarefa"
            >
              <tr>
                <td><!--Spacer--></td>
                <td>{{ tarefa.titulo }}</td>
                <template
                  v-for="(recorrencia, index) in getRecorrenciasOrdenadas(tarefa.recorrencias)"
                  :key="index"
                >
                  <td class="has-text-centered is-relative">
                    <TrfGlobalLoader type="overlay" v-if="isLoading && recorrenciaSelecionada == recorrencia.historicoTarefaId" :spinnerSize="'4'" style="background: white;"  />
                    <span v-if="!recorrencia.status">
                      -
                    </span>

                    <TrfDropdownButton
                      v-else-if="recorrencia.status?.id == this.statusEnum.ATRASADA || recorrencia.status?.id == this.statusEnum.PENDENTE"
                      @click="_acaoIcone(recorrencia, dado.empresaId)" 
                      class="trf-dropdown-button-empresa-listagem" 
                      :btnOptions="getOpcoesDropdownEConcatenarIdComOIdDoHistorico(recorrencia)" 
                      :identificador="`empresa-listagem-${recorrencia.historicoTarefaId}`"
                      alinhamentoAoAbrir="is-right">
                      <template #nomeDropdown>
                        <FontAwesomeIcon
                          size="2x"
                          :icon="adquirirIconeStatus(recorrencia.status)"
                          :style="{
                            color: adquirirCorStatus(recorrencia.status),
                          }"
                        />
                     </template>

                    </TrfDropdownButton>

                    <span v-else @click="_acaoIcone(recorrencia, dado.empresaId)" class="recorrencia-status-icon">
                      <FontAwesomeIcon
                        size="2x"
                        :icon="adquirirIconeStatus(recorrencia.status, recorrencia.acaoStatus)"
                        :style="{
                          color: adquirirCorStatus(recorrencia.status),
                        }"
                      />
                      <div class="tooltip" v-if="recorrencia.acaoStatus">
                       {{ tooltipText }}
                      </div>
                    </span>
                  </td>
                </template>
              </tr>
            </template>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import TrfGlobalLoader from "../../../../components/GlobalLoader";
import TrfDropdownButton from "../../../../components/DropdownButton";

export default {
  name: "DashboardEmpresaListagem",
  components: {
    FontAwesomeIcon,
    TrfGlobalLoader,
    TrfDropdownButton
  },
  props: {
    dados: {
      type: Array,
    },
    periodo: null,
    isLoading: Boolean,
    opcoesDropdown: Array
  },
  data() {
    return {
      controle: [],
      recorrenciaSelecionada: false,
      tooltipText: ''
    };
  },
  methods: {
      getOpcoesDropdownEConcatenarIdComOIdDoHistorico(recorrencia){
      return this.opcoesDropdown.map(opcao => {
        return {
          ...opcao,
          id: `${opcao.id}-${recorrencia.historicoTarefaId}`
        };
      });
    },
    _acaoIcone(recorrencia, idEmpresa) {
      if(!!this.isLoading) return;
      this.recorrenciaSelecionada = recorrencia.historicoTarefaId;
      this.$emit('trf-empresa-icon-click', recorrencia, idEmpresa);
    },
    mostrarDados(indexDado) {      
      this.controle[indexDado] = this.controle[indexDado]
        ? !this.controle[indexDado]
        : true;
      return this.controle[indexDado];
    },
    cardBorderColor(empresa) {
      const statusIDasString = `${empresa.status.id}`;
      switch (statusIDasString) {
        case this.statusEnum.ATRASADA:
          return "trf-empresa-card-atrasado";
          break;
        case this.statusEnum.PENDENTE:
          return "trf-empresa-card-pendente";
          break;
        case this.statusEnum.CONCLUIDO:
          return "trf-empresa-card-recebido";
          break;
      }
    },
    adquirirIconeStatus(status, acaoStatus) {
      const statusIDasString = `${status.id}`;
      switch (statusIDasString) {
        case this.statusEnum.ATRASADA:
          return "fa-triangle-exclamation";
          break;
        case this.statusEnum.PENDENTE:
          return "fa-clock";
          break;
        case this.statusEnum.CONCLUIDO:
          return this.adquirirIconeStatusDeAcordoComOTipoDeAcaoDoStatus(acaoStatus);
          break;
      }
    },

    adquirirIconeStatusDeAcordoComOTipoDeAcaoDoStatus(acaoStatus){
      if(!acaoStatus) {
        return "fa-check";
      } else {
        this.tooltipText = "Concluída manualmente"
        return "fa-user-check";
      }
    },

    adquirirCorStatus(status) {
      const statusIDasString = `${status.id}`;
      switch (statusIDasString) {
        case this.statusEnum.ATRASADA:
          return "#E33B3C";
          break;
        case this.statusEnum.PENDENTE:
          return "#5692E6";
          break;
        case this.statusEnum.CONCLUIDO:
          return "#32AA45";
          break;
      }
    },
    getRecorrenciasOrdenadas(recorrencias) {
      const recorrenciasOrdenadas = [];
      this.colunasPeriodo.forEach(coluna => {
        const recorrenciaSelecionada = recorrencias.find(recorrencia => {
          return coluna == this.converterDataBackEmMesEAno(recorrencia.data);
        })
        recorrenciasOrdenadas.push(recorrenciaSelecionada? recorrenciaSelecionada : {});
      })
      return recorrenciasOrdenadas;
    },
    converterDataBackEmMesEAno(data) {
      const mes = data.slice(5, 7);
      const ano = data.slice(0, 4);
      return `${mes}/${ano}`;
    }
  },
  computed: {
    colunasPeriodo() {
      if (!this.periodo.dataInicial) return;
      const list = [];
      const dataInicial = {
        dia: parseInt(this.periodo.dataInicial.slice(8, 10)),
        mes: parseInt(this.periodo.dataInicial.slice(5, 7)),
        ano: parseInt(this.periodo.dataInicial.slice(0, 4)),
      };

      let date = new Date(dataInicial.ano, dataInicial.mes - 1);
      let month = ("0" + `${date.getMonth() + 1}`).slice(-2);
      list.push(`${month}/${date.getFullYear()}`);
      for (let i = 0; i < 11; i++) {
        date = new Date(dataInicial.ano, dataInicial.mes + i);
        let month = ("0" + `${date.getMonth() + 1}`).slice(-2);
        list.push(`${month}/${date.getFullYear()}`);
      }
      return list;
    },
    statusEnum() {
      const status = {
        PENDENTE: "1",
        ATRASADA: "5",
        CONCLUIDO: "2",
      };
      return status;
    },

    acaoStatusEnum() {
      const acaoStatus = {
        CONCLUSAO_MANUAL: 1
      };
      return acaoStatus;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/sass/variables.scss";
.table {
  width: 100%;
  &.is-borderless {
    tr,
    td,
    th {
      border: 0 none;
    }
  }
}
.card {
  &-header {
    position: relative;
  }
  &-content {
    max-height: 0px;
    height: auto;
    padding: 0 1.5em;
    overflow: hidden;
    transition: max-height 0.45s ease 0s, padding 0.45s ease 0s;
    &.active {
      height: auto;
      padding: 1.5em;
      max-height: 5000px;
      overflow: auto;
    }
  }
  &.trf-empresa {
    &-card {
      &-atrasado {
        border-left: 1em solid $danger;
      }
      &-pendente {
        border-left: 1em solid $info;
      }
      &-recebido {
        border-left: 1em solid $success;
      }
    }
  }
}
.columns.is-0 > .column {
  padding-left: 0;
  padding-right: 0;
}
.columns.is-1 > .column {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.columns.is-2 > .column {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.columns.is-3 > .column {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.columns.is-4 > .column {
  padding-left: 1rem;
  padding-right: 1rem;
}
.columns.is-5 > .column {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.columns.is-6 > .column {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.columns.is-7 > .column {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.columns.is-8 > .column {
  padding-left: 2rem;
  padding-right: 2rem;
}

.tooltip {
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  min-width: auto;
  padding: 0.5em 0.2em;
  position: absolute;
  z-index: 1;
  top:80%;
  border-radius: 5px;
  left: 50%;
  transform:translateX(-50%);
  background-color: #fff;
  box-shadow: 0 2px 15px rgb(50 50 93 / 10%), 0 2px 15px rgb(0 0 0 / 7%);
  transition: opacity 0.35s ease 0s;
  font-size: 12px;
}

.recorrencia-status-icon:hover .tooltip {
  opacity: 0.75;
  pointer-events: auto;
}
</style>
<style lang="scss">
.trf-dropdown-button-empresa-listagem {
  & .button.is-primary {
    background-color: #FFF;
    color: #000;
    &:hover {
      background-color: #FFF;
      color: #000;
    }
    &:focus:not(:active), &.is-focused:not(:active){
      box-shadow:0 0 0 0.125em rgb(251, 255, 251);
      color: #000;
    }
    & .icon{
      padding-bottom:0.8rem;
    }
  }
  & .dropdown-content {
    margin-left: 0 !important;
    padding: 0.1rem 0;
    & .dropdown-item {
      padding-right: 1rem;
      padding-left: 0.5rem;
    }
  }
}
</style>